import type { UUID, ISODateString, Nullable } from './common';

export type ItemStatus =
  | 'not_started'
  | 'inquired'
  | 'quoted'
  | 'contract_requested'
  | 'booked';

export interface Item {
  id: UUID;
  categoryId: UUID;
  vendorId: UUID | null;
  name: string;
  status: ItemStatus;
  notes: Nullable<string>;
  sortOrder: number;
  vendorContactName: string | null;
  vendorEmail: string | null;
  vendorPhone: string | null;
  vendorWebsite: string | null;
  estimatedCost: number | null;
  isSelectedForProject: boolean;
  createdAt: ISODateString;
  updatedAt: ISODateString;
}

export const ITEM_STATUS_LABELS: Record<ItemStatus, string> = {
  not_started: 'Not Started',
  inquired: 'Inquired',
  quoted: 'Quoted',
  contract_requested: 'Contract Requested',
  booked: 'Booked',
};
